import { render, staticRenderFns } from "./DirectoryDataTab.vue?vue&type=template&id=2a73beef&scoped=true"
import script from "./DirectoryDataTab.vue?vue&type=script&lang=js"
export * from "./DirectoryDataTab.vue?vue&type=script&lang=js"
import style0 from "./DirectoryDataTab.vue?vue&type=style&index=0&id=2a73beef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73beef",
  null
  
)

export default component.exports